module.exports = __webpack_public_path__ + "img/sertifikat-mnemo.33aa5fe4.jpg";